<template>
  <div
    style="
      width: 100%;
      height: 100%;
      overflow: hidden;
      display: flex;
      flex-direction: column;
    "
  >
    <ul style="display: flex; padding: 10px 10px 0 10px">
      <li
        style="
          flex: 1;
          font-weight: 600;
          font-size: 14px;
          color: rgb(60, 60, 60);
        "
      >
        工资表
      </li>
      <el-button
        type="primary"
        :icon="Plus"
        link
        @click="state.showAdd = true"
        v-if="$judge_auth('103')"
      >
        创建工资表
      </el-button>
    </ul>
    <div class="list-box" style="flex: 1">
      <ul class="list-search">
        <el-space wrap style="flex: 1">
          <el-input
            v-model="state.params.keywords"
            style="width: 200px"
            placeholder="名称、单号"
            clearable
            @clear="
              delete state.params.keywords;
              onLoad();
            "
            @paste.enter="$onKeywordsPaste($event, state.params)"
          ></el-input>
          <el-input
            v-model="state.params.keywords_employee"
            style="width: 200px"
            placeholder="员工姓名、手机号、证件号"
            clearable
            @clear="
              delete state.params.keywords_employee;
              onLoad();
            "
            @paste.enter="
              $onKeywordsPaste($event, state.params, 'keywords_employee')
            "
          ></el-input>
          <el-select
            v-model="state.params.customer_id"
            placeholder="所属客户"
            style="width: 200px"
          >
            <el-option
              v-for="item in state.customerData"
              :key="item"
              :label="item.name"
              :value="item.id"
            />
            <template #footer>
              <el-button size="small" @click="onLoadCustomer()">
                刷新
              </el-button>
            </template>
          </el-select>
          <el-date-picker
            v-model="state.params.month"
            type="month"
            format="YYYY年M月"
            value-format="YYYY-MM"
            placeholder="薪资所属期"
            style="width: 200px"
          />
          <el-date-picker
            v-model="state.params.tax_month"
            type="month"
            format="YYYY年M月"
            value-format="YYYY-MM"
            placeholder="税款所属期"
            style="width: 200px"
          />
          <el-select
            v-model="state.params.d_tax_type_id"
            placeholder="报税类型"
            style="width: 200px"
          >
            <el-option
              v-for="item in state.taxTypeData"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
            <template #footer>
              <el-button size="small" @click="onLoadTaxType()">
                刷新
              </el-button>
            </template>
          </el-select>
          <el-date-picker
            v-model="state.dates"
            type="daterange"
            range-separator="至"
            start-placeholder="--发放日期--"
            end-placeholder="--发放日期--"
            style="width: 300px"
            value-format="YYYY-MM-DD"
            @change="
              (value) => {
                if (value) state.params.pay_date = value[0] + ' - ' + value[1];
              }
            "
            @clear="
              delete state.dates;
              delete state.params.pay_date;
            "
          />
          <el-tree-select
            v-model="state.params.belonger_id"
            :props="{
              value: 'id',
              label: 'name',
              class: 'belonger-tree-class',
            }"
            placeholder="负责人"
            :data="state.admin_data"
            style="width: 200px"
            default-expand-all
            filterable
            clearable
          >
            <template #default="{ data }">
              <el-icon :size="16" v-if="data.type == 0"><UserFilled /></el-icon>
              <el-icon :size="16" v-else><User /></el-icon>
              <span style="margin-left: 3px">{{ data.name }}</span>
            </template>
          </el-tree-select>
          <el-config-provider
            :value-on-clear="null"
            :empty-values="[undefined, null]"
          >
            <el-select
              v-model="state.params.is_need_re_calc_tax"
              placeholder="是否需重新算税"
              style="width: 200px"
            >
              <el-option label="需要重新算税" :value="1" />
              <el-option label="无需重新算税" :value="0" />
            </el-select>
          </el-config-provider>
          <el-dropdown split-button @click="onLoad" type="primary">
            查询
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item :icon="RefreshLeft" @click="onReset()">
                  重置
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </el-space>
      </ul>
      <ul class="list-table">
        <el-table
          :data="state.tableData"
          v-loading="!Array.isArray(state.tableData)"
          element-loading-background="rgba(0, 0, 0, 0.2)"
          :default-sort="{
            prop: state.params.sort_field,
            order:
              state.params.sort_value == 'desc' ? 'descending' : 'ascending',
          }"
          class="payroll-list-table"
          @sort-change="onSortChange"
          border
        >
          <el-table-column
            fixed
            label="序号"
            width="70"
            type="index"
            :index="
              (index) =>
                (state.params.page - 1) * state.params.limit + index + 1
            "
            align="center"
          />
          <el-table-column
            label="状态/单号"
            prop="status"
            sortable="status"
            width="120"
            fixed="left"
          >
            <template #default="{ row }">
              <c_tabgroup>
                <template #top>
                  <text
                    :style="{ color: row.status == 0 ? '#1e90ff' : '#080' }"
                  >
                    {{ row.status == 0 ? "操作中" : "已完成" }}
                  </text>
                  <el-tag
                    type="danger"
                    size="small"
                    title="需重新算税"
                    style="cursor: pointer; margin-left: 5px"
                    v-if="row.is_need_re_calc_tax"
                    >重
                  </el-tag>
                </template>
                <template #bottom>
                  <text
                    style="color: #1e90ff"
                    class="text-hover-decoration"
                    :title="row.order_id"
                    @click="$onCopy(row.order_id)"
                  >
                    {{ row.order_id }}
                  </text>
                </template>
              </c_tabgroup>
            </template>
          </el-table-column>
          <el-table-column
            prop="name"
            sortable="name"
            label="名称"
            :formatter="
              (row, column, cellValue) =>
                $tab_Highlinght(cellValue, state.params.keywords)
            "
            :min-width="260"
          >
            <template #default="{ row }">
              <div>
                <span
                  v-if="row.type == 1"
                  style="
                    color: #fff;
                    font-size: 11px;
                    padding: 2px;
                    line-height: 12px;
                    background-color: #1e90ff;
                    border-radius: 2px;
                  "
                  >0申报</span
                >
                {{ row.name }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="customer_name"
            label="所属客户"
            :formatter="$tab_ShowToolTip"
            :min-width="220"
          />
          <el-table-column
            prop="d_service_name"
            label="客户服务类型"
            :formatter="$tab_ShowToolTip"
            :width="120"
          />
          <el-table-column
            prop="d_tax_type_name"
            label="报税类型"
            :formatter="$tab_ShowToolTip"
            :width="160"
          />
          <el-table-column
            prop="month"
            label="薪资所属期"
            :formatter="$tab_ShowToolTip"
            :width="120"
          />
          <el-table-column
            prop="tax_month"
            label="税款所属期"
            :formatter="$tab_ShowToolTip"
            :width="120"
          />
          <el-table-column
            prop="pay_date"
            label="发放日期"
            :formatter="$tab_ShowToolTip"
            :width="120"
          />
          <el-table-column
            prop="employee_num"
            label="员工数量"
            :formatter="$tab_NumberFormat"
            align="center"
            :width="120"
          />
          <el-table-column
            prop="settle_amount"
            label="结算金额"
            :formatter="$tab_MoneyFormat"
            align="center"
            :width="120"
            fixed="right"
          />
          <el-table-column
            label="实发金额"
            align="center"
            :width="120"
            fixed="right"
          >
            <template #default="{ row }">
              <c_money
                :value="row.pay_amount"
                style="margin: 0 auto; color: #080; font-weight: 600"
              ></c_money>
            </template>
          </el-table-column>
          <el-table-column
            label="个税金额"
            align="center"
            :width="100"
            fixed="right"
          >
            <template #default="{ row }">
              <c_money
                :value="
                  row.tax_mode == 0
                    ? row.personal_income_tax
                    : row.company_income_tax
                "
                style="margin: 0 auto; color: #1e90ff; font-weight: 600"
              ></c_money>
            </template>
          </el-table-column>
          <el-table-column
            prop="arrearage_amount"
            label="欠款"
            :formatter="$tab_PriceFormat"
            align="center"
            :width="120"
          />
          <el-table-column
            prop="paied_amount"
            label="已发放"
            :formatter="$tab_PriceFormat"
            align="center"
            :width="120"
          />
          <el-table-column
            prop="belonger_name"
            label="负责人"
            :formatter="
              (row) =>
                $tab_GroupFormat(
                  row.belonger_name,
                  row.belonger_department_name || ''
                )
            "
            min-width="160"
          >
          </el-table-column>
          <el-table-column label="算税人数" :width="200">
            <template #default="{ row }">
              <div
                style="
                  width: 100%;
                  display: flex;
                  column-gap: 10px;
                  cursor: pointer;
                "
              >
                <el-tag
                  type="info"
                  :title="`未算税：${row.uncalc_tax_num}人`"
                  size="small"
                >
                  {{ row.uncalc_tax_num }}
                </el-tag>
                <el-tag
                  type="success"
                  :title="`已算税：${row.calc_tax_num}人`"
                  size="small"
                >
                  {{ row.calc_tax_num }}
                </el-tag>
                <el-tag
                  type="danger"
                  :title="`算税失败：${row.failure_calc_tax_num}人`"
                  size="small"
                >
                  {{ row.failure_calc_tax_num }}
                </el-tag>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="发薪人数" :width="200">
            <template #default="{ row }">
              <div
                style="
                  width: 100%;
                  display: flex;
                  column-gap: 10px;
                  cursor: pointer;
                "
              >
                <el-tag
                  type="info"
                  :title="`未发薪：${row.unpayed_num}人`"
                  size="small"
                >
                  {{ row.unpayed_num }}
                </el-tag>
                <el-tag
                  type="primary"
                  :title="`发薪中：${row.paying_num}人`"
                  size="small"
                >
                  {{ row.paying_num }}
                </el-tag>
                <el-tag
                  type="success"
                  :title="`已发薪：${row.payed_num}人`"
                  size="small"
                >
                  {{ row.payed_num }}
                </el-tag>
                <el-tag
                  type="danger"
                  :title="`发放失败：${row.failure_payed_num}人`"
                  size="small"
                >
                  {{ row.failure_payed_num }}
                </el-tag>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="创建信息"
            :formatter="
              (row) =>
                $tab_GroupFormat(
                  row.add_admin_name + '/' + row.add_department_name,
                  row.create_time || ''
                )
            "
            min-width="160"
          >
          </el-table-column>
          <!-- <el-table-column
            label="金额明细"
            align="center"
            :width="260"
            fixed="right"
          >
            <template #default="{ row }">
              <div
                style="
                  width: 100%;
                  display: grid;
                  column-gap: 10px;
                  cursor: pointer;
                  grid-template-columns: repeat(2, 1fr);
                  margin-left: 20px;
                "
              >
                <div
                  data-type="结"
                  title="结算金额"
                  :style="{
                    '--dynamic-color': '#f00',
                  }"
                  class="withholding-badge"
                  style="font-weight: 600; color: #f00; text-align: left"
                >
                  {{ $priceFormat(row.settle_amount) }}
                </div>
                <div
                  data-type="实"
                  title="实发金额"
                  :style="{
                    '--dynamic-color': '#080',
                  }"
                  class="withholding-badge"
                  style="font-weight: 600; color: #080; text-align: left"
                >
                  {{ $priceFormat(row.pay_amount) }}
                </div>
                <div
                  data-type="欠"
                  title="欠款金额"
                  :style="{
                    '--dynamic-color': '#ffa500',
                  }"
                  class="withholding-badge"
                  style="font-weight: 600; color: #ffa500; text-align: left"
                >
                  {{ $priceFormat(row.arrearage_amount) }}
                </div>
                <div
                  data-type="个"
                  title="个税金额"
                  :style="{
                    '--dynamic-color': '#1e90ff',
                  }"
                  class="withholding-badge"
                  style="font-weight: 600; color: #1e90ff; text-align: left"
                >
                  {{
                    $priceFormat(
                      row.tax_mode == 0
                        ? row.personal_income_tax
                        : row.company_income_tax
                    )
                  }}
                </div>
              </div>
            </template>
          </el-table-column> -->
          <el-table-column
            label="操作"
            width="100"
            align="center"
            fixed="right"
          >
            <template #default="{ row }">
              <div
                style="
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                  justify-content: center;
                "
              >
                <el-button
                  type="primary"
                  link
                  icon="Edit"
                  @click="
                    $store.commit('openMenu', {
                      path: 'PayrollDetail',
                      title: '工资表管理-' + row.order_id,
                      refresh: true,
                      data: {
                        id: row.id,
                      },
                    })
                  "
                  v-if="$judge_auth('104')"
                >
                  管理
                </el-button>
                <el-button
                  type="primary"
                  link
                  icon="View"
                  @click="
                    $store.commit('openMenu', {
                      path: 'PayrollDetail',
                      title: '工资表详情-' + row.order_id,
                      refresh: true,
                      data: {
                        id: row.id,
                      },
                    })
                  "
                  style="margin-left: 0"
                  v-else
                >
                  查看
                </el-button>
                <el-button
                  type="danger"
                  link
                  icon="Delete"
                  @click="onDelete(row.id)"
                  v-if="$judge_auth('106')"
                  style="margin-left: 0"
                >
                  删除
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <c_page
          :total="state.totalCount"
          :pageIndex="state.params.page"
          :pageSize="state.params.limit"
          @onLoad="
            (page) => {
              state.params.page = page.pageIndex;
              state.params.limit = page.pageSize;
              onLoad();
            }
          "
        />
      </ul>
    </div>
  </div>
  <transition name="el-zoom-in-center">
    <c_popup
      v-if="state.showAdd"
      title="添加工资表"
      @close="state.showAdd = false"
    >
      <c_PayrollInfo @close="onAddConfirm"></c_PayrollInfo>
    </c_popup>
  </transition>
</template>

<script>
import { onMounted, reactive } from "vue";
import { payroll_list, payroll_delete } from "@/http/payroll";
import { admin_cascader } from "@/utils/qFormat";
import { data_customer_select } from "@/http/data";
import { taxtype_select } from "@/http/dictionary";
import { confirm_func } from "@/utils/qFormat";
import store from "@/store";

class InitFormData {
  params = {
    limit: 100,
    page: 1,
    sort_field: "create_time",
    sort_value: "desc",
  };
}
export default {
  setup() {
    const state = reactive(new InitFormData());
    onMounted(() => {
      onLoadCustomer();
      onLoadTaxType();
      onLoadAdmin();
      onLoad();
    });

    const onLoad = () => {
      delete state.tableData;

      payroll_list(state.params).then((res) => {
        if (res.status == 200) {
          const { count, list } = res.data.data;
          state.tableData = list;
          state.totalCount = count;
        }
      });
    };

    //获取客户
    const onLoadCustomer = () => {
      data_customer_select().then((res) => {
        if (res.status == 200) state.customerData = res.data.data?.list;
      });
    };

    //获取业务员
    const onLoadAdmin = () => {
      admin_cascader().then((res) => {
        state.admin_data = res;
      });
    };

    const onLoadTaxType = () => {
      taxtype_select().then((res) => {
        if (res.status == 200) state.taxTypeData = res.data.data;
      });
    };

    const onDateChange = (value) => {
      if (value && value.length == 2)
        state.params.pay_date = value[0] + " - " + value[1];
    };

    //排序
    const onSortChange = ({ column }) => {
      if (column.order) {
        state.params.sort_field = column.sortable;
        state.params.sort_value = column.order === "ascending" ? "asc" : "desc";
      } else {
        const params = new InitFormData().params;
        state.params.sort_field = params.Order;
        state.params.sort_value = "asc";
      }
      onLoad();
    };

    //重置查询条件
    const onReset = () => {
      Object.assign(state, new InitFormData());
      onLoad();
    };

    const onAddConfirm = (id) => {
      state.showAdd = false;
      onLoad();
      if (id) {
        store.commit("openMenu", {
          path: "PayrollDetail",
          title: "工资表详情",
          refresh: true,
          data: {
            id,
          },
        });
      }
    };

    //删除
    const onDelete = (id) => {
      confirm_func(payroll_delete, id, onLoad);
    };

    return {
      state,
      onLoad,
      onSortChange,
      onReset,
      onDelete,
      onLoadCustomer,
      onLoadAdmin,
      onLoadTaxType,
      onDateChange,
      onAddConfirm,
    };
  },
};
</script>
<style scoped>
.num_box {
  border-radius: 3px;
  width: 30px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  color: #fff;
  cursor: pointer;
}
</style>
<style lang="less">
.payroll-list-table {
  border-top: 0 !important;
  border-left: 0 !important;
  border-right: 0 !important;

  .el-table__body {
    .el-table__cell {
      border-right: none !important;
    }
  }
}
</style>
